// Subtle parallax tilt on the phone mock
(function () {
  const phone = document.querySelector('.phone');
  if (!phone) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  const hero = document.querySelector('.hero');
  let raf = 0;

  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;

    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const rx = (-y * 6).toFixed(2);
      const ry = (x * 8 - 3).toFixed(2);
      phone.style.transform = `perspective(1200px) rotate(-3deg) rotateX(${rx}deg) rotateY(${ry}deg)`;
    });
  });

  hero.addEventListener('mouseleave', () => {
    phone.style.transform = 'rotate(-3deg)';
  });
})();

// Reveal-on-scroll for cards and steps
(function () {
  const els = document.querySelectorAll('.card, .step, .quote, .section-head');
  if (!('IntersectionObserver' in window) || !els.length) return;

  els.forEach((el) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  els.forEach((el) => io.observe(el));
})();
